/* eslint-disable no-debugger */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
import React, {
  memo, useState, useEffect, useRef,
} from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import IdleTimer from 'react-idle-timer';
import { useDispatch, useSelector } from 'react-redux';
import AuthHelper from '../../utils/AuthHelper';
import Footer from '../Layout/Footer';
import IdealTimerModal from '../common/Modal/IdealTimerModal';
import Toast from '../common/Toast/Toast';
import { setAuthToken } from '../../redux/slices/userDataSlice';
import { setSearchKey, setSearchloading } from '../../redux/slices/searchSlice';

function RequireAuth({ children }) {
  const timeout = 3000000;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isIdle, setIsIdle] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const idleTimerRef = useRef(null);
  const loc = useLocation();
  const { searchKey } = useSelector((state) => state.search) || {};
  const location = loc?.pathname;
  useEffect(() => {
    let logoutTimer;
    if (isIdle && showWarning) {
      logoutTimer = setTimeout(() => {
        setIsIdle(false);
        AuthHelper.clearAll();
        dispatch(setAuthToken(false));
        navigate('/login');
      }, 10000);
    }
    if (location !== '/search' && searchKey && searchKey !== '') {
      dispatch(setSearchKey(''));
      dispatch(setSearchloading(false));
    }
    return () => {
      clearTimeout(logoutTimer);
    };
  }, [isIdle, showWarning, location]);

  const handleOnIdle = () => {
    setShowWarning(true);
    setIsIdle(true);
  };

  const handleOnActive = () => {
    setIsIdle(false);
  };

  const handleOnAction = () => {
    setIsIdle(false);
  };
  const handleKeepsIn = () => {
    setShowWarning(false);
    setIsIdle(false);
  };

  const handlelogout = () => {
    setIsIdle(false);
    AuthHelper.clearAll();
    dispatch(setAuthToken(false));
    navigate('/login');
  };
  if (!AuthHelper.getAuthToken()) {
    return <Navigate to="/login" />;
  }
  if (jwtDecode(AuthHelper.getAuthToken()).exp < Date.now() / 1000) {
    localStorage.clear();
    Toast('Session timeout.Please login again.', 'error');
    return <Navigate to="/login" />;
  }
  return (
    <>
      <IdleTimer
        ref={idleTimerRef}
        timeout={timeout}
        onIdle={handleOnIdle}
        onActive={handleOnActive}
        onAction={handleOnAction}
      />
      <>
        <div
          className={
            !(
              location === '/plans'
              || location === '/renew-plan'
              || location === '/payment'
              || location === '/payment-success'
            )
              ? 'content-area'
              : ''
          }
        >
          {children}
          {!(
            location === '/plans'
            || location === '/renew-plan'
            || location === '/payment'
            || location === '/payment-success'
          ) && <Footer />}
        </div>
        <IdealTimerModal show={showWarning} onHide={handleKeepsIn} logout={handlelogout} />
      </>
    </>
  );
}

export default memo(RequireAuth);
